// extracted by mini-css-extract-plugin
module.exports = {"container":"_404-module--container--3T6-O","subContainer":"_404-module--sub-container--13D8h","textContainer":"_404-module--text-container--2pySs"};